// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".video-tour-frame{width:660px;height:470px}@media(min-width:1200px){.video-tour-frame{width:1000px;height:500px}}", ""]);
// Exports
module.exports = exports;
